import React, { useState, useEffect } from 'react'
import { Table, Panel } from 'rsuite'
import { Icon, IconButton, ButtonGroup, Modal, Button } from 'rsuite'
import { budgetFormat } from '../../../../utils/formatterUtil'

export default function ContributionBudgetTable({ schema, onDelete, onEdit, ...props }) {
  const { isEdit } = props
  const { Column, HeaderCell, Cell } = Table

  const [isdelete, setIsdelete] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState()

  return (
    <Panel eventKey={2} bodyFill>
      <div>
        <Table
          rowKey="id"
          height={400}
          autoHeight={schema.value.length <= 5}
          wordWrap={true}
          data={schema.value}
        >
          <Column width={70} fixed align="center">
            <HeaderCell>ลำดับที่</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column minWidth={280} width={280} flexGrow={1}>
            <HeaderCell>{schema.organization.label}</HeaderCell>
            <Cell dataKey={schema.organization.name} />
          </Column>

          <Column width={180}>
            <HeaderCell>{schema.budget.label}</HeaderCell>
            {/* <Cell dataKey={schema.budget.name} /> */}
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.budget)
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>{schema.otherSupport.label}</HeaderCell>
            <Cell dataKey={schema.otherSupport.name} />
          </Column>
          {isEdit && (
            <Column width={200} align="center" fixed="right" verticalAlign="middle">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={(e) => {
                          onEdit(rowData, index)
                        }}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={(e) => {
                          setIsdelete(true)
                          setDeleteIndex(index)
                        }}
                      >
                        ลบ
                      </IconButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      <Modal
        backdrop="static"
        size="xs"
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบ ' + (schema.buttonText ? schema.buttonText : '')}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteIndex)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteIndex('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </Panel>
  )
}
